import {FORM_ORDER_RETURN_ASSIGN} from 'shared/constants/ActionTypes';

const initalState = {
  formOrderAssign: {},
};

const reducer = (state = initalState, action) => {
  switch (action.type) {
    case FORM_ORDER_RETURN_ASSIGN:
      return {
        ...state,
        formOrderAssign: action.payload,
      };

    default:
      return state;
  }
};

export default reducer;
